// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"30507d88","453":"235ae63a"}[chunkId] + ".chunk.js";
};